module.exports = __webpack_public_path__ + "static/media/game-board-alt.e453ed0b.svg";